import React, { useState } from 'react';
import SubNav from '../components/subNav';
import SEO from '../components/SEO';
import { useNavigate } from 'react-router-dom';
import Screen from'../assets/img/ScreenCover.jpg';
import { baseUrl } from '../config';

import "../styles/Ebook.css";



const categories = [
    {
      name: "Popular Roles",
      books: [
        { title: "Director's Handbook", author: "A. Filmmaker", cover: "/api/placeholder/150/225" },
        { title: "Actor's Guide", author: "B. Hollywood", cover: "/api/placeholder/150/225" },
        { title: "Cinematography Essentials", author: "C. Lens", cover: "/api/placeholder/150/225" },
        { title: "Producer's Playbook", author: "D. Mogul", cover: "/api/placeholder/150/225" },
        { title: "Art Direction Mastery", author: "E. Visionary", cover: "/api/placeholder/150/225" },
        { title: "Sound Design Secrets", author: "F. Audiophile", cover: "/api/placeholder/150/225" },
      ]
    },
    {
      name: "AI in Filmmaking",
      books: [
        { title: "AI for Screenwriting", author: "G. Future", cover: Screen },
        { title: "AI Scriptwriting Techniques", author: "H. Writer", cover: "/api/placeholder/150/225" },
        { title: "ProducerBuddy AI Tools", author: "H. Efficiency", cover: "/api/placeholder/150/225" },
        { title: "AI-Assisted Editing", author: "I. Montage", cover: "/api/placeholder/150/225" },
        { title: "Machine Learning in VFX", author: "J. Render", cover: "/api/placeholder/150/225" },
        { title: "AI-Powered Casting", author: "K. Talent", cover: "/api/placeholder/150/225" },
        { title: "Automated Post-Production", author: "L. Workflow", cover: "/api/placeholder/150/225" },
      ]
    },
    {
      name: "Pre-Production",
      books: [
        { title: "Script Analysis Mastery", author: "M. Plottwist", cover: "/api/placeholder/150/225" },
        { title: "Budgeting for Success", author: "N. Finance", cover: "/api/placeholder/150/225" },
        { title: "Location Scouting 101", author: "O. Scenic", cover: "/api/placeholder/150/225" },
        { title: "Storyboarding Techniques", author: "P. Visual", cover: "/api/placeholder/150/225" },
        { title: "Casting Strategies", author: "Q. Ensemble", cover: "/api/placeholder/150/225" },
        { title: "Production Design Essentials", author: "R. Set", cover: "/api/placeholder/150/225" },
      ]
    },
    {
      name: "Production",
      books: [
        { title: "On-Set Management", author: "S. Organized", cover: "/api/placeholder/150/225" },
        { title: "Lighting for Film", author: "T. Luminous", cover: "/api/placeholder/150/225" },
        { title: "Camera Movement Mastery", author: "U. Steady", cover: "/api/placeholder/150/225" },
        { title: "Directing Actors", author: "V. Performance", cover: "/api/placeholder/150/225" },
        { title: "Sound Recording Techniques", author: "W. Crystal", cover: "/api/placeholder/150/225" },
        { title: "Special Effects on a Budget", author: "X. Illusion", cover: "/api/placeholder/150/225" },
      ]
    },
    {
      name: "Post-Production",
      books: [
        { title: "Editing Theory and Practice", author: "Y. Cut", cover: "/api/placeholder/150/225" },
        { title: "Color Grading Mastery", author: "Z. Palette", cover: "/api/placeholder/150/225" },
        { title: "Sound Mixing for Film", author: "AA. Acoustic", cover: "/api/placeholder/150/225" },
        { title: "VFX Pipeline Management", author: "BB. Render", cover: "/api/placeholder/150/225" },
        { title: "Music Scoring for Film", author: "CC. Melody", cover: "/api/placeholder/150/225" },
        { title: "Trailer Editing Techniques", author: "DD. Tease", cover: "/api/placeholder/150/225" },
      ]
    },
];

const SearchBar = ({ onSearch }) => (
  <div className="film-ebook-search-container">
    <input
      type="text"
      placeholder="Search books by title or author..."
      onChange={(e) => onSearch(e.target.value)}
      className="film-ebook-search-input"
    />
  </div>
);

const CategorySection = ({ category, searchTerm }) => {
  const filteredBooks = category.books.filter(book => 
    book.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    book.author.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (filteredBooks.length === 0) return null;

  return (
    <div className="film-ebook-category">
      <h2 className="film-ebook-category-title">
        {category.name}
      </h2>
      <div className="film-ebook-book-grid">
        {filteredBooks.map((book, index) => (
          <BookCard key={index} book={book} />
        ))}
      </div>
    </div>
  );
};

const BookCard = ({ book }) => {
  const navigate = useNavigate();

  const handleBookClick = () => {
    if (book.title === "AI for Screenwriting") {
      navigate('/Scriptwritter');
    }
  };

  return (
    <div className="film-ebook-book-card" onClick={handleBookClick}>
      <img src={book.cover} alt={book.title} className="film-ebook-book-cover" />
      <div className="film-ebook-book-info">
        <h3 className="film-ebook-book-title">{book.title}</h3>
        <p className="film-ebook-book-author">{book.author}</p>
      </div>
    </div>
  );
};

const FilmIndustryEbook = () => {
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <div>
      <SEO
        title="Film Industry Ebooks"
        description="Download free and premium film industry ebooks covering screenwriting, production, distribution, and more from ProducerBuddy."
        url="https://producerbuddy.pilomation.com/ebook"
      />
      <SubNav />
      <div className="film-ebook-container">
        <h1 className="film-ebook-title">Film Industry Ebook Collection</h1>
        <SearchBar onSearch={setSearchTerm} />
        
        {categories.map((category, index) => (
          <CategorySection key={index} category={category} searchTerm={searchTerm} />
        ))}
        
        <div className="film-ebook-featured">
          <h2 className="film-ebook-featured-title">Featured: ProducerBuddy AI Tools</h2>
          <p className="film-ebook-featured-description">
            Discover how ProducerBuddy's AI tools are revolutionizing the film industry. From script analysis to scheduling assistance, learn how to leverage cutting-edge technology to streamline your production process.
          </p>
          <button className="film-ebook-button">
            Explore AI Tools
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilmIndustryEbook;
